import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Incoterms from '../../models/Incoterms';


export interface IncotermsDetailState extends ApiState {
  incoterms?: Incoterms
}

export default requestReducer<IncotermsDetailState>('INCOTERMS_DETAIL')
